import type { Agent } from '@entities/user';
import type { AgentListRepository } from '@infra/repositories/agent.repository';

export class MemAgentRepository implements AgentListRepository {
  private _agent?: Agent[];
  static getAgents: Agent[];

  constructor(agents: Agent[] = []) {
    this._agent = agents;
  }

  getAgents(): Promise<Agent[]> {
    return Promise.resolve(this._agent as Agent[]);
  }

  async addAgent(agent: Agent[]): Promise<void> {
    this._agent = this._agent?.concat([...agent]);
  }

  async updateAgents(agents: Agent[]): Promise<void> {
    this._agent = [...agents];
  }
}
